import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../Buttons'

const LanguageToggle = () => {
  const { i18n } = useTranslation()

  const changeLanguage = lng => {
    i18n.changeLanguage(lng)
  }

  const languages = [
    { code: 'pt-BR', label: 'Português' },
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'es-AR', label: 'Español (Ar)' },
    { code: 'es-CO', label: 'Español (Co)' },
    { code: 'es-PE', label: 'Español (Pe)' }
  ]

  return (
    <div className="d-flex gap-1 row-gap-0 justify-content-center py-2 border-top flex-wrap">
      {languages.map(({ code, label }) => (
        <Button
          key={code}
          size="xsmall"
          template={i18n.language === code ? 'secondary' : 'tertiary'}
          onClick={() => changeLanguage(code)}
          customWidth="auto"
        >
          <small>{label}</small>
        </Button>
      ))}
    </div>
  )
}

export default LanguageToggle
